const localSegmentSelection = {
  clearLocalData() {
    window.localStorage.removeItem('dayRange');
    window.localStorage.removeItem('__segmentTop__');
    window.localStorage.removeItem('__segmentMeasure__');
    window.localStorage.removeItem('__websiteId__');
    window.localStorage.removeItem('__segmentSysId__');
    window.localStorage.removeItem('__granularity__');
  }
};

export default localSegmentSelection;


// WEBPACK FOOTER //
// ./src/utils/localSegmentSelecttion.js